const LARGE = 1279;

const loadImages = ( $menu ) => {
  $menu.find( '.tab-panel.active .item-thumbnail' ).each( function() {
    let $image = $( this ).find( 'img' );

    if ( $image && $image.length > 0 ) {
      if ( ! $image.hasClass( 'lazy-loaded' ) ) {
        $image.attr( 'src', $image.data( 'src' ) );
        $image.addClass( 'lazy-loaded' );
      }
    }
  });
};

const menuNameOnHover = ( menu ) => {

  let timer = false;

  menu.find( '.tab-names .tab-name' ).stop().mouseover( function() {

    if ( window.innerWidth < LARGE ) {
      return;
    }

    if ( timer ) {
      clearTimeout( timer );
    }
    let tab = $( this );
    let name = tab.data( 'name' );
    let panel = menu.find( '.tab-panel[data-name="' + name + '"]' );
    let activeClass = 'active';

    timer = setTimeout( () => {

      if ( tab.is( ':hover' ) ) {

        // Remove Old Active Class
        if ( window.innerWidth >= LARGE ) {
          menu.find( '.tab-panel.' + activeClass ).fadeOut( 150 );
        }
        menu.find( '.tab-panel.' + activeClass ).removeClass( activeClass );
        menu.find( '.tab-name.' + activeClass ).removeClass( activeClass );

        // Add new active Class
        if ( ! panel.hasClass( activeClass ) ) {

          panel.addClass( activeClass );
          tab.addClass( activeClass );

          loadImages( menu );

          setTimeout( () => {
            panel.fadeIn( 200 );
          }, 300 );

        }
      }
    }, 300 );
  });
};

const rpMenuNameOnClick = ( menu ) => {

  menu.find( '.tab-names .tab-name' ).click( function() {

    if ( window.innerWidth >= LARGE ) {
      return;
    }

    let tab = $( this );
    let name = tab.data( 'name' );
    let panel = menu.find( '.tab-panel[data-name="' + name + '"]' );
    let activeClass = 'active';
    activeClass = 'mobile-active';
    panel.addClass( activeClass );
    tab.addClass( activeClass );

  });
};

const switchMegaMenuTab = () => {
  $( '.mega-menu' ).each( function() {
    let menu = $( this );

    // Close mega menu
    menu.find( '.go-back .arrow-left' ).on( 'click', function() {
      menu.removeClass( 'mega-menu-open' );
      menu.removeClass( 'mega-menu-open--responsive' );
      $( '.chr-white-overlay' ).fadeOut();
    });

    menuNameOnHover( menu );
    rpMenuNameOnClick( menu );
  });
};

const shouldShowMegaMenu = () => {
  let delay = 200;

  $( '.show-mega-menu-btn' ).mouseenter( function() {
    if ( window.innerWidth >= LARGE && ! $( 'body' ).hasClass( 'show-flag-dropdown' ) &&
      ! $( 'body' ).hasClass( 'search-form-open' ) ) {

      $( '.chr-header .mega-menu.mega-menu-open' ).removeClass( 'mega-menu-open' );

      $( this ).find( '.mega-menu' ).addClass( 'mega-menu-open' );
      $( '.chr-white-overlay' ).fadeIn();
      $( this ).find( '.mega-menu .tab-panel.active' ).fadeIn( 200 );
      if ( ! $( this ).find( '.mega-menu' ).hasClass( 'has-inited' ) ) {
        loadImages( $( this ).find( '.mega-menu' ) );
        $( this ).find( '.mega-menu' ).addClass( 'has-inited' );
      }
    }
  }).mouseleave( function() {
    if ( window.innerWidth >= LARGE ) {
      setTimeout( () => {
        if ( ! $( this ).find( '.mega-menu' ).is( ':hover' ) ) {
          $( '.chr-white-overlay' ).fadeOut();
          $( this ).find( '.mega-menu' ).removeClass( 'mega-menu-open' );
        }
      }, delay );
    }
  });

  $( '.show-mega-menu-btn' ).each( function() {
    let wrapper = $( this );
    wrapper.find( '> a' ).on( 'click', function( evt ) {
      if ( window.innerWidth < LARGE ) {
        evt.preventDefault();
        if ( $( this ).data( 'count' ) === 1 ) {
          const $menu = $( this ).next( '.mega-menu' );
          $menu.addClass( 'mega-menu-open--responsive' );
          if ( ! $menu.hasClass( 'has-inited' ) ) {
            loadImages( $menu );
            $menu.addClass( 'has-inited' );
          }
          $menu.find( '.tab-panel' ).addClass( 'mobile-active' );
        } else {
          wrapper.find( '.mega-menu' ).addClass( 'mega-menu-open--responsive' );
          if ( ! wrapper.find( '.mega-menu' ).hasClass( 'has-inited' ) ) {
            loadImages( wrapper.find( '.mega-menu' ) );
            wrapper.find( '.mega-menu' ).addClass( 'has-inited' );
          }
        }
      }
    });
  });

  $( '.tab-panel--go-back .arrow-left' ).on( 'click', function() {
    $( this ).parent().parent().removeClass( 'mobile-active' );
    if ( $( this ).parent().data( 'count' ) === 1 ) {
      let megamenu = $( this ).parent().parent().parent().parent().parent();
      megamenu.removeClass( 'mega-menu-open--responsive' );
    }
  });
};

const handleMegaMenuClick = () => {
  $( '.mega-menu' ).each( function() {
    let menu = $( this );

    menu.find( '.tab-name' ).on( 'click', function( evt ) {

      if ( window.innerWidth < LARGE ) {
        evt.preventDefault();
      }
    });
  });
};

$( document ).ready( () => {
  shouldShowMegaMenu();
  switchMegaMenuTab();
  handleMegaMenuClick();
});
